import React from "react";
import "./Dark_Blue_Btn.css";
import { Button } from "react-bootstrap";

const Dark_Blue_Btn = ({ btnText, onClick }) => {
  return (
    <button className="Dark_Blue_Btn" onClick={onClick}>
      {btnText}
    </button>
  );
};

export default Dark_Blue_Btn;
